<template>
  <v-card
    elevation="2"
    class="pa-3"
  >
    <v-form
      v-model="valid"
      ref="form"
    >
      <PageTitle
        icon="mdi-pencil-box-outline"
        main="Assistência Social"
        sub="Gera remessas de devolução"
        home="/social"
      />
      <input
        id="user-id"
        type="hidden"
        v-model="remessa.usuario"
      />
      <v-row>
        <v-col
          cols="12"
          md="2"
        >
          <v-text-field
            v-model="remessa.id"
            label="Código"
            outlined
            dense
          >
            <v-icon
              slot="append"
              color="success"
              large
              @click="loadDialog"
            >
              mdi-magnify
            </v-icon>
          </v-text-field>
        </v-col>
        <v-col
          cols="12"
          md="2"
        >
          <h5>Número da remmessa<br /><span>{{ numRemessa }}</span></h5>
          <h4>Soma: {{ registros.valor }} </h4>
        </v-col>
        <v-col
          cols="12"
          md="3"
          v-if="codigo"
        >
          <v-checkbox
            v-model="remessa.inativar"
            label="Inativar remessa ?"
            color="success"
            v-show="mode === 'save'"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="4"
        >
          <v-menu
            v-model="menu1"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-mask="dta"
                v-model="data_env"
                label="Data de envio.:"
                dense
                outlined
                @blur="mudaData"
              >
                <v-icon
                  slot="append"
                  color="success"
                  large
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-calendar
                </v-icon>
              </v-text-field>
            </template>
            <v-date-picker
              locale="pt-br"
              v-model="date"
              @input="dateB"
            >
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            max-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="time"
                v-mask="hra"
                dense
                outlined
                label="Hora do envio.:"
                @blur="mudaHora"
              >
                <v-icon
                  slot="append"
                  color="success"
                  large
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-clock-time-four-outline
                </v-icon>
              </v-text-field>
            </template>
            <v-time-picker
              v-if="menu"
              v-model="time"
              full-width
              @click:minute="horaA"
            ></v-time-picker>
          </v-menu>
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <v-text-field
            v-model="remessa.cd_cliente"
            label="Código do cliente.:"
            clearable
            outlined
            required
            dense
            hint="Recomendado 033126723"
            v-if="mode === 'save'"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="4"
        >
          <v-text-field
            v-model="remessa.nr_agencia"
            label="Número da agência.:"
            clearable
            outlined
            required
            dense
            hint="Recomendado 0900-8"
            v-if="mode === 'save'"
          ></v-text-field>
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <v-text-field
            v-model="remessa.nr_conta"
            label="Número da conta.:"
            clearable
            outlined
            required
            dense
            hint="Recomendado 23456-7"
            v-if="mode === 'save'"
          ></v-text-field>
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <v-text-field
            v-model="remessa.cd_ppg"
            label="Código do parâmetro.:"
            clearable
            outlined
            required
            dense
            hint="Recomendado 38"
            v-if="mode === 'save'"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-card>
        <v-tabs
          v-model="tabs"
          height="45"
        >
          <v-tab @click="loadLotes">
            <v-icon class="mr-2">
              mdi-note-text
            </v-icon>
            Lote
          </v-tab>
        </v-tabs>
        <v-divider></v-divider>
        <v-tabs-items v-model="tabs">
          <v-tab-item>
            <v-card flat>
              <v-row justify="space-around">
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-card>
                    <v-card-title>
                      Dados do lote
                    </v-card-title>
                    <v-data-table
                      v-if="lote"
                      :headers="headersLot"
                      :items="lotes"
                      :search="search"
                    >
                      <template v-slot:[`item.actions`]="{ item }">
                        <v-icon
                          medium
                          color="primary"
                          class="mr-2"
                          @click="loadBeneficiario(item)"
                        >
                          mdi-square-edit-outline
                        </v-icon>
                        <v-icon
                          medium
                          color="error"
                          class="mr-2"
                          @click="loadBeneficiario(item, 'remove')"
                        >
                          mdi-delete
                        </v-icon>
                      </template>
                    </v-data-table>
                    <v-data-table
                      v-if="list"
                      :headers="headersLot"
                      :items="beneficiarios"
                      :search="search"
                    >
                      <template v-slot:[`item.actions`]="{ item }">
                        <v-icon
                          medium
                          color="primary"
                          class="mr-2"
                          @click="persistir(item)"
                        >
                          mdi-square-edit-outline
                        </v-icon>
                      </template>
                    </v-data-table>
                    <v-row v-if="!lote">
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-btn
                          color="success"
                          class="ml-4 mb-2"
                          v-if="codigo"
                          @click="loadSelect"
                        >
                          <v-icon left>
                            mdi-folder-upload-outline
                          </v-icon>
                          Adicionar
                        </v-btn>
                        <v-btn
                          color="success"
                          class="ml-4 mb-2"
                          v-if="codigo"
                          @click="loadImport"
                        >
                          <v-icon left>
                            mdi-folder-table-outline
                          </v-icon>
                          Importar
                        </v-btn>
                        <v-btn
                          color="success"
                          class="ml-4 mb-2"
                          v-if="codigo"
                          @click="persistir"
                        >
                          <v-icon left>
                            mdi-content-save
                          </v-icon>
                          Salvar lote
                        </v-btn>
                        <v-btn
                          class="ml-4 mb-2"
                          color="blue-grey"
                          @click="resetLista"
                        >
                          Limpar
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row v-if="btnGera">
                      <v-col
                        cols="12"
                        sm="6"
                        md="3"
                      >
                        <v-btn
                          color="indigo"
                          class="ml-4 mb-2"
                          @click="geraLayout"
                          dark
                        >
                          <v-icon left>
                            mdi-content-save
                          </v-icon>
                          gerar layout
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
      <v-row class="mt-4">
        <v-col
          cols="12"
          md="10"
        >
          <v-btn
            :disabled="!valid"
            color="success"
            class="mr-4"
            v-if="mode === 'save'"
            @click="save"
          >
            <v-icon left>
              mdi-content-save
            </v-icon>
            Salvar
          </v-btn>
          <v-btn
            :disabled="!valid"
            color="success"
            class="mr-4"
            v-if="mode === 'save'"
            @click="saveBeneficio"
          >
            <v-icon left>
              mdi-content-save
            </v-icon>
            Up beneficios
          </v-btn>
          <v-btn
            v-if="btnConta"
            color="success"
            class="mr-4"
            @click="geraConta"
          >
            <v-icon left>
              mdi-content-save
            </v-icon>
            Gera contas
          </v-btn>
          <v-btn
            color="error"
            class="mr-4"
            v-if="mode === 'remove'"
            @click="remove"
          >
            <v-icon left>
              mdi-content-save
            </v-icon>
            Deletar
          </v-btn>
          <v-btn
            color="indigo"
            dark
            class="mr-4"
            v-if="this.lote"
            :href="urlRel"
          >
            <v-icon left>
              mdi-content-save
            </v-icon>
            Gerar remessa
          </v-btn>
          <v-btn
            color="secondary"
            class="mr-4"
            @click="reset"
          >
            <v-icon left>
              mdi-broom
            </v-icon>
            Limpar
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
    <v-row justify="space-around">
      <v-col cols="auto">
        <v-dialog
          v-model="dialog"
          transition="dialog-bottom-transition"
          fullscreen
        >
          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar
                color="primary"
                dark
              >
                Pesquisar boletins
              </v-toolbar>
              <v-card-title>
                <v-text-field
                  class="search"
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Pesquisar"
                  single-line
                  hide-details
                >
                </v-text-field>
              </v-card-title>
              <v-data-table
                :headers="headers"
                :items="remessas"
                :search="search"
              >
                <template v-slot:[`item.actions`]="{ item }">
                  <v-icon
                    medium
                    color="primary"
                    class="mr-2"
                    @click="loadRemessa(item)"
                  >
                    mdi-square-edit-outline
                  </v-icon>
                  <v-icon
                    medium
                    color="error"
                    class="mr-2"
                    @click="loadRemessa(item, 'remove')"
                  >
                    mdi-delete
                  </v-icon>
                </template>
              </v-data-table>
              <v-card-actions class="justify-end">
                <v-btn
                  color="error"
                  @click="dialog.value = false"
                >Fechar</v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </v-col>
    </v-row>
    <v-container>
      <v-dialog
        v-model="addFoto"
        transition="dialog-top-transition"
      >
        <template v-slot:default="dialog">
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >
              Adicionar mídia
            </v-toolbar>
            <v-card
              elevation="2"
              class="pa-3"
            >
              <div class="ma-5">
                <PageTitle
                  icon="mdi-pencil-box-outline"
                  sub="beneficiarios ou vídeos do covid19"
                />
                <v-form>
                  <input
                    id="user-id"
                    type="hidden"
                    v-model="foto.usuario"
                  />
                  <input
                    id="foto-id"
                    type="hidden"
                    v-model="foto.id"
                  />
                  <input
                    id="foto-uuid"
                    type="hidden"
                    v-model="foto.uuid"
                  />
                  <input
                    id="uid_boletim"
                    type="hidden"
                    v-model="foto.uuid_boletim"
                  />
                  <v-row>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-text-field
                        v-model="codigo"
                        label="Código"
                        dense
                        filled
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="3"
                      v-if="codigo"
                    >
                      <v-checkbox
                        v-model="foto.inativar"
                        label="Inativar Foto?"
                        color="success"
                        class="mt-0 mb-2"
                        v-show="mode === 'save'"
                      ></v-checkbox>
                    </v-col>
                    <v-col
                      cols="12"
                      md="3"
                      v-if="codigo"
                    >
                      <v-checkbox
                        v-model="foto.site_img"
                        label="Substituir texto por imagem ?"
                        color="success"
                        class="mt-0 mb-2"
                        v-show="mode === 'save'"
                      ></v-checkbox>
                    </v-col>
                    <v-col
                      cols="12"
                      md="3"
                    >
                      <v-menu
                        v-model="menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-mask="dtpub"
                            v-model="data_publicacao"
                            label="Data de publicação.:"
                            dense
                            outlined
                            @blur="mudaDataMidia"
                          >
                            <v-icon
                              slot="append"
                              color="success"
                              large
                              v-bind="attrs"
                              v-on="on"
                            >
                              mdi-calendar
                            </v-icon>
                          </v-text-field>
                        </template>
                        <v-date-picker
                          locale="pt-br"
                          v-model="date"
                          @input="dateF"
                        >
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                  <v-row>
                    <input
                      accept="image/png, image/jpeg, image/bmp"
                      prepend-icon="mdi-camera"
                      label="Arquivo de imagem"
                      v-if="uploadReady"
                      type="file"
                      ref="file"
                      @change="selectFile()"
                    >
                  </v-row>
                </v-form>
              </div>
              <v-card-actions class="justify-end">
                <v-btn
                  color="success"
                  class="mr-4"
                  v-if="codigo"
                  type="submit"
                  @click.prevent="fileUpload()"
                >
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Salvar
                </v-btn>
                <v-btn
                  color="error"
                  class="mr-4"
                  v-if="codigo"
                  @click="clearUpload"
                >
                  Remover
                  <v-icon left>
                    mdi-broom
                  </v-icon>
                </v-btn>
                <v-btn
                  color="danger"
                  class="mr-4"
                  @click="dialog.value = false"
                >
                  Sair
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-card>
        </template>
      </v-dialog>
    </v-container>
    <v-container>
      <div class="text-center">
        <v-dialog
          v-model="importProt"
          width="700"
        >
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >
              Filtrar protocolos
            </v-toolbar>
            <v-card
              elevation="2"
              class="pa-3"
            >
              <v-row>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-select
                    v-model="tpFiltro.acao"
                    label="Tipo de ação"
                    :items="acoes"
                    clearable
                    outlined
                    dense
                  ></v-select>
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-select
                    v-model="tpFiltro.parcela"
                    label="Parcela"
                    :items="parcelas"
                    clearable
                    outlined
                    dense
                  ></v-select>
                </v-col>
              </v-row>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="indigo"
                  text
                  @click.prevent="loadBeneficiarios"
                >Importar</v-btn>
                <v-btn
                  color="primary"
                  text
                  @click="importProt = false"
                >
                  Cancelar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-dialog>
      </div>
    </v-container>
    <v-container>
      <div class="text-center">
        <v-dialog
          v-model="importPess"
          width="700"
        >
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >
              Selecionar conta a ser cancelada
            </v-toolbar>
            <v-card
              elevation="2"
              class="pa-3"
            >
              <v-row>
                <v-col
                  cols="12"
                  md="5"
                >
                  <v-text-field
                    v-model="opcoes.protocolo"
                    label="número do protocolo"
                    type="text"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="1"
                >
                  <v-btn
                    color="indigo"
                    text
                    @click.prevent="loadProtocolos"
                  >
                    <v-icon
                      color="success"
                      large
                    >
                      mdi-magnify
                    </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row justify="space-around">
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-card>
                    <v-card-title>
                      Dados da conta
                    </v-card-title>
                    <v-data-table
                      :headers="headersProt"
                      :items="contas"
                      :search="search"
                    >
                      <template v-slot:[`item.actions`]="{ item }">
                        <v-icon
                          v-if="!conta.id"
                          medium
                          color="primary"
                          class="mr-2"
                          @click="loadConta(item)"
                        >
                          mdi-download-box-outline
                        </v-icon>
                        <v-icon
                          medium
                          color="error"
                          class="mr-2"
                          @click="loadConta(item, 'remove')"
                        >
                          mdi-delete
                        </v-icon>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-col>
              </v-row>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="indigo"
                  text
                  @click.prevent="loadAddProtocolo"
                >
                  <v-icon
                    medium
                    color="primary"
                    class="mr-2"
                  >
                    mdi-content-save
                  </v-icon>
                  Salvar
                </v-btn>
                <v-btn
                  color="primary"
                  text
                  @click="closeProtocolo"
                >
                  Cancelar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-dialog>
      </div>
    </v-container>
  </v-card>
</template>

<script>
import PageTitle from '@/components/template/PageTitle'
import { mapState } from 'vuex'
import { uuid } from 'vue-uuid'
import { baseApiUrl, showError } from '@/global'
import moment from 'moment'
import axios from 'axios'

export default {
  name: 'DevolucaoRecursos',
  components: { PageTitle },
  computed: mapState(['user']),
  data: () => ({
    uuid: '',
    hra: '##:##:##',
    dta: '##/##/####',
    dtpub: '##/##/####',
    tabs: null,
    lote: false,
    list: false,
    codigo: '',
    importPess: false,
    importProt: false,
    url_interna: false,
    dialog: false,
    addFoto: false,
    addDoc: false,
    btnGera: false,
    btnConta: false,
    uploadReady: true,
    date: new Date().toISOString().substr(0, 10),
    date1: new Date().toISOString().substr(0, 10),
    dataEnv: '',
    horaEnv: '',
    data_env: '',
    data_publicacao: '',
    menu: false,
    menu1: false,
    time: '',
    file: '',
    tabela: 'informativo',
    search: '',
    mode: 'save',
    numRemessa: '',
    opcoes: {},
    tpFiltro: {},
    remessa: {},
    lastRemessa: {},
    init: '2',
    init1: '',
    remessas: [],
    locais: [],
    beneficios: [],
    foto: {},
    registros: {},
    totRegistros: {},
    trailer: {},
    beneficiario: {},
    beneficiarios: [],
    contas: [],
    conta: {},
    lotes: [],
    movim: [],
    length: '',
    acoes: [
      { value: 'C', text: 'Cancelar devolução' },
      { value: 'D', text: 'Solicitar devolução' }
    ],
    parcelas: [
      { value: '1', text: '1ª Parcela' },
      { value: '2', text: '2ª Parcela' },
      { value: '3', text: '3ª Parcela' }
    ],
    targets: [
      { value: '_top', text: '_top' },
      { value: '_self', text: '_self' },
      { value: '_blank', text: '_blank' }
    ],
    headers: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Remessa', value: 'nr_remessa' },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersLot: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Cod remessa', value: 'uid_remessa' },
      { text: 'Sequencial', value: 'sequencial' },
      { text: 'Protocolo', value: 'protocolo' },
      { text: 'Cpf', value: 'cgc' },
      { text: 'Senha', value: 'senha' },
      { text: 'Ação', value: 'acao' },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersProt: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Protocolo', value: 'protocolo' },
      { text: 'Cpf', value: 'cpf' },
      { text: 'Movimento antigo', value: 'tp_movin_antigo' },
      { text: 'Tipo movimento', value: 'tp_movimento' },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    valid: false,
    urlRel: ''
  }),
  methods: {
    dateF () {
      this.data_publicacao = moment(this.date1).format('DD/MM/YYYY')
      this.menu = false
    },
    dateB () {
      this.data_env = moment(this.date).format('DD/MM/YYYY')
      this.menu1 = false
    },
    horaA () {
      this.menu = false
    },
    mudaData () {
      const [dia, mes, ano] = this.data_env.split('/')
      this.date = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
      this.dataEnv = `${dia.padStart(2, '0')}${mes.padStart(2, '0')}${ano}`
    },
    mudaDataMidia () {
      const [dia, mes, ano] = this.data_publicacao.split('/')
      this.date1 = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    mudaHora () {
      const [hh, mm, ss] = this.time.split(':')
      this.horaEnv = `${hh}${mm}${ss}`
    },
    validate () {
      this.$refs.form.validate()
    },
    save () {
      this.remessa.data_env = this.date
      this.remessa.dataEnv = this.dataEnv
      this.remessa.hora_env = this.time
      this.remessa.horaEnv = this.horaEnv
      const method = this.remessa.id ? 'put' : 'post'
      const id = this.remessa.id ? `/${this.remessa.id}` : ''
      axios[method](`${baseApiUrl}/adm-adm-gera-layout-ppg103${id}`, this.remessa)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.reset()
        })
        .catch(showError)
    },
    geraLayout () {
      const method = 'put'
      const id = `/${this.remessa.id}`
      axios[method](`${baseApiUrl}/adm-adm-gera-trailer-ppg103${id}`, this.trailer)
        .then(() => {
          this.$toasted.global.defaultSuccess()
        })
        .catch(showError)
    },
    selectFile () {
      this.file = this.$refs.file.files[0]
    },
    persistir () {
      const method = 'post'
      axios[method](`${baseApiUrl}/adm-adm-gera-persist-layout-ppg103`, this.beneficiarios)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadLote()
          this.upBeneficio()
          this.loadRegistros()
          this.btnGera = true
        })
        .catch(showError)
    },
    loadAddProtocolo () {
      const method = 'put'
      const CC = this.conta.id
      axios[method](`${baseApiUrl}/adm-adm-gera-update-layout-ppg103/${CC}`, this.conta)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadLote()
          this.upBeneficio()
          this.loadRegistros()
          this.btnGera = true
        })
        .catch(showError)
    },
    geraConta () {
      const method = 'post'
      axios[method](`${baseApiUrl}/adm-adm-gera-conta-beneficio`, this.movim)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.btnConta = false
        })
        .catch(showError)
    },
    saveBeneficio () {
      const id = 1
      const method = 'put'
      axios[method](`${baseApiUrl}/adm-adm-gera-layout-upBeneficio/${id}`, this.beneficios)
        .then(() => {
          this.$toasted.global.defaultSuccess()
        })
        .catch(showError)
    },
    async docUpload () {
      const formData = new FormData()
      const url = `${baseApiUrl}/doc-remessa-informativo`
      formData.append('uuid', this.doc.uuid)
      formData.append('uuid_informativo', this.remessa.uuid)
      formData.append('uid_informativo', this.remessa.id)
      formData.append('data_publicacao', this.date1)
      formData.append('tabela', this.tabela)
      formData.append('pasta', this.remessa.id)
      formData.append('usuario', this.doc.usuario)
      formData.append('file', this.file)
      await axios.post(url, formData)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.resetUpload()
        })
        .catch(showError)
    },
    clearUpload () {
      this.uploadReady = false
      this.$nextTick(() => {
        this.uploadReady = true
      })
    },
    resetUpload () {
      this.file = ''
      this.foto = {}
      this.doc = {}
      this.uploadReady = false
      this.$nextTick(() => {
        this.uploadReady = true
      })
    },
    remove () {
      alert('Deseja realmente remover?')
    },
    loadRemessas () {
      const url = `${baseApiUrl}/adm-adm-gera-layout-ppg103`
      axios.get(url).then(res => {
        this.remessas = res.data
      })
    },
    loadLastRemessa () {
      const url = `${baseApiUrl}/adm-adm-remessa-last-devolucao`
      axios.get(url).then(res => {
        this.lastRemessa = res.data
        if (this.lastRemessa.id) {
          const nrRem = this.lastRemessa.nr_remessa
          const valIni = 1
          this.remessa.nr_remessa = parseInt(nrRem) + parseInt(valIni)
          this.numRemessa = this.remessa.nr_remessa
        } else {
          this.remessa.nr_remessa = '1'
          this.numRemessa = this.remessa.nr_remessa
        }
      })
      this.remessa.nr_seq = '1'
    },
    loadFiltross () {
      const url = `${baseApiUrl}/adm-adm-filtro`
      axios.get(url).then(res => {
        this.filtro = res.data.map(item => {
          return {
            ...item,
            dataP: moment(item.created_at).format('DD/MM/YYYY [às ] hh:mm')
          }
        })
      })
    },
    loadLote () {
      const idM = this.remessa.id
      const url = `${baseApiUrl}/adm-adm-gera-persist-layout-ppg103/${idM}`
      axios.get(url).then(res => {
        this.lotes = res.data
        this.list = false
        this.btnConta = true
        this.loadRegistros()
        this.loadTotRegistros()
        this.loadMovim()
      })
    },
    loadMovim () {
      const idM = this.remessa.id
      const url = `${baseApiUrl}/adm-adm-lista-movim-devolucao/${idM}`
      axios.get(url).then(res => {
        this.movim = res.data.map(item => {
          return {
            ...item,
            uid_beneficio: Number(String(item.uid_beneficio).substr(-4, 4)).toString(),
            nr_conta: String(item.uid_beneficio).substr(6, 9).toString()
          }
        })
        this.btnConta = true
      })
    },
    upBeneficio () {
      const idM = this.remessa.id
      const url = `${baseApiUrl}/adm-adm-gera-layout-upBeneficio/${idM}`
      axios.get(url).then(res => {
        this.beneficios = res.data.map(item => {
          return {
            ...item,
            uidBeneficio: Number(String(item.uidBeneficio).substr(-4, 4)).toString(),
            conta: true
          }
        })
      })
    },
    loadRegistros (cod) {
      const idM = this.codigo
      const url = `${baseApiUrl}/adm-adm-soma-colunas-ppg103/${idM}`
      axios.get(url).then(res => {
        this.registros = res.data
        //  const val = this.registros.total
        const reg = this.registros.registros
        //  this.trailer.tot_valor = ('00000000000' + val).slice(-11)
        this.trailer.tot_registros = ('000000000' + reg).slice(-9)
        this.trailer.gerado = true
      })
    },
    loadTotRegistros (cod) {
      const idM = this.codigo
      const url = `${baseApiUrl}/adm-adm-seq-colunas-ppg103/${idM}`
      axios.get(url).then(res => {
        this.totRegistros = res.data
        const sq = this.totRegistros.seq_mov
        const seqMv = parseInt(sq) + parseInt(1)
        this.trailer.seq_trailer = ('000000000' + seqMv).slice(-9)
      })
    },
    loadProtocolos () {
      const url = `${baseApiUrl}/adm-adm-processo-conta-beneficio/${this.opcoes.protocolo}`
      axios.get(url).then(res => {
        this.contas = res.data.map(item => {
          return {
            ...item,
            cpf: item.cpf,
            protocolo: item.protocolo,
            tp_movimento: 'D',
            usuario: this.user.id
          }
        })
      })
    },
    loadBeneficiarios () {
      const url = `${baseApiUrl}/adm-adm-processo-conta/${this.tpFiltro.acao}`
      axios.get(url).then(res => {
        this.beneficiarios = res.data.map(item => {
          return {
            ...item,
            cgc: item.cgc,
            senha: item.senha,
            protocolo: ('000000' + item.protocolo).slice(-15),
            uid_remessa: this.remessa.id,
            tp_registro: '1',
            valor: '00000030000',
            acao: '4',
            sequencial: ('000000000' + this.init++).slice(-9),
            usuario: this.user.id,
            inativar: false
          }
        })
      })
      this.list = true
      this.lote = false
      this.importProt = false
    },
    closeProtocolo () {
      this.importPess = false
      this.conta = {}
      this.contas = []
    },
    loadSelect () {
      this.importPess = true
      this.opcoes = {}
    },
    loadImport () {
      this.importProt = true
      this.opcoes = {}
    },
    addNewTodo: function () {
      this.todos.push({
        id: this.nextTodoId++,
        title: this.newTodoText
      })
      this.newTodoText = ''
    },
    loadRemessa (remessa, mode = 'save') {
      this.mode = mode
      this.remessa = { ...remessa }
      this.codigo = this.remessa.id
      this.date = this.remessa.data_env
      this.time = this.remessa.hora_env
      this.numRemessa = this.remessa.nr_remessa
      this.data_env = moment(this.remessa.data_env).format('DD/MM/YYYY')
      this.dialog = false
      this.valid = true
      console.log(remessa.gerado)
      if (remessa.gerado === 1) {
        this.btnGera = false
        this.lote = true
        this.loadLote()
        this.upBeneficio()
        const dt = moment(remessa.data_env).format('DDMMYYYY')
        const [hh, mm] = remessa.hora_env.split(':')
        const hs = `${hh}${mm}`
        const idRel = remessa.id
        const nm = `${dt}${hs}`
        this.urlRel = `${baseApiUrl}/gera-remessa-bb-ppg103/${idRel}/nome?nm=${nm}`
      }
    },
    loadConta (conta, mode = 'save') {
      this.mode = mode
      this.conta = { ...conta }
    },
    abilitaTarget () {
      this.url_interna = this.remessa.url_interna
    },
    loadBeneficiario () {

    },
    loadLotes () {
      this.loadLote()
      this.upBeneficio()
      this.lote = true
    },
    loadLocais () {
      const url = `${baseApiUrl}/local-da-pagina`
      axios.get(url).then(res => {
        this.locais = res.data.map(locais => {
          return {
            value: locais.id,
            text: `${locais.local_page}`
          }
        })
      })
    },
    reset () {
      this.mode = 'save'
      this.btnGera = false
      this.btnConta = false
      this.remessa = {}
      this.lotes = []
      this.beneficiarios = []
      this.codigo = ''
      this.remessa.uuid = uuid.v1()
      this.remessa.usuario = this.user.id
      this.loadDatas()
    },
    resetLista () {
      this.beneficiarios = []
      this.init = 2
    },
    loadDialog () {
      this.dialog = true
      this.loadRemessas()
    },
    persist () {
      this.foto.uuid = uuid.v1()
      this.foto.usuario = this.user.id
      this.dateF()
      this.addFoto = true
    },
    loadAddDoc () {
      this.doc.uuid = uuid.v1()
      this.doc.usuario = this.user.id
      this.dateF()
      this.addDoc = true
    },
    loadUser () {
      this.remessa.uuid = uuid.v1()
      this.remessa.usuario = this.user.id
      this.loadLastRemessa()
      this.loadLocais()
      this.dateB()
    },
    loadDatas () {
      const dataAgora = new Date().toISOString().substr(0, 10)
      this.data_env = moment(dataAgora).format('DD/MM/YYYY')
      this.date = dataAgora
    }
  },
  mounted () {
    this.loadUser()
  }
}
</script>

<style scoped>
.container {
  width: 98% !important;
}
</style>
